import React, { useMemo } from 'react';

import styles from './DeviceSettingsAdvanced.module.css';

import { Heading3Bold } from '../../../components/common/text/Heading3Bold';
import { TextSmallMedium } from '../../../components/common/text/TextSmallMedium';

import { DeviceSettingsAdvancedSetting } from './DeviceSettingsAdvancedSetting';

export function DeviceSettingsAdvanced(props) {
  function getLabel(setting) {
    const label = setting.label ?? setting.title;
    return label != null && setting.units != null ? `${label} (${setting.units})` : label;
  }

  const advancedSettings = useMemo(() => {
    return props.advancedSettings.sort((a, b) => {
      if (a.type !== 'group' && b.type === 'group') {
        return -1;
      }
      if (a.type === 'group' && b.type !== 'group') {
        return 1;
      }
      return 0;
    });
  }, [props.advancedSettings]);

  return (
    <div className={styles.root}>
      <Heading3Bold className={styles.heading}>Advanced Settings</Heading3Bold>

      {advancedSettings.map((object, index) => {
        if (object.type === 'group') {
          return (
            <React.Fragment key={index}>
              <div className={styles.groupLabel}>
                <TextSmallMedium>{getLabel(object)}</TextSmallMedium>
              </div>
              {object.children.map((setting) => {
                return (
                  <DeviceSettingsAdvancedSetting
                    key={setting.id}
                    device={props.device}
                    setting={setting}
                    register={props.register}
                    control={props.control}
                    errors={props.errors}
                  />
                );
              })}
            </React.Fragment>
          );
        }
        return (
          <DeviceSettingsAdvancedSetting
            key={object.id}
            device={props.device}
            setting={object}
            register={props.register}
            control={props.control}
            errors={props.errors}
          />
        );
      })}
    </div>
  );
}
